import { StarIcon } from 'app/components/core/icons';
import Skeleton from 'app/components/flat/ui/Skeleton';

import * as S from './styles';

type PaymentMethodCardProps =
  | { isLoading: true }
  | {
      brandLabel: string;
      brandIconUrl?: string | null;
      lastDigits: string;
      expirationDate: string;
      isPrimary?: boolean;
      menu?: React.ReactNode;
    };

const PaymentMethodCardSkeleton = () => (
  <>
    <S.Info>
      <Skeleton width={32} height={32} borderRadius={6} />
      <S.Details>
        <Skeleton width={160} height={14} borderRadius={999} />
        <Skeleton width={100} height={14} borderRadius={999} />
      </S.Details>
    </S.Info>
    <Skeleton width={32} height={32} borderRadius={5} />
  </>
);

const PaymentMethodCardContent = ({
  brandLabel,
  brandIconUrl,
  lastDigits,
  expirationDate,
  isPrimary = false,
  menu,
}: Exclude<PaymentMethodCardProps, { isLoading: true }>) => (
  <>
    <S.Info>
      {brandIconUrl ? (
        <S.BrandIcon src={brandIconUrl} alt={`Bandeira ${brandLabel}`} />
      ) : (
        <S.BrandPlaceholder aria-hidden />
      )}
      <S.Details>
        <S.CardLabel>
          {brandLabel} •••• {lastDigits}
        </S.CardLabel>
        <S.Expiration>Validade {expirationDate}</S.Expiration>
        {isPrimary ? (
          <S.PrimaryBadge data-testid="primary-badge">
            <StarIcon size={8} color="#0182AB" />
            Principal
          </S.PrimaryBadge>
        ) : null}
      </S.Details>
    </S.Info>
    {!isPrimary && menu ? menu : null}
  </>
);

const PaymentMethodCard = (props: PaymentMethodCardProps) => {
  if ('isLoading' in props) {
    return (
      <S.Card data-testid="payment-method-card-skeleton" data-loading>
        <PaymentMethodCardSkeleton />
      </S.Card>
    );
  }

  return (
    <S.Card data-testid="payment-method-card">
      <PaymentMethodCardContent {...props} />
    </S.Card>
  );
};

export default PaymentMethodCard;
export { Divider, List } from './styles';
